import { sortBy, isEqual, findIndex } from "lodash"
import storageUtil from "./base"
const tabpageStorageUtil = {

  //get all tabpage and create it if not exist 
  getAllTabpages() {
    if (!storageUtil.isExist('tabpage')) {
      storageUtil.addStorage('tabpage', [])
    }
    let res = storageUtil.getStorage('tabpage')
    if (res.status === true) {
      return res.msg
    } else {
      throw new Error(res.msg)
    }
  },
  updateTabpages(tabpageArr) {
    storageUtil.updateStorage('tabpage', tabpageArr)
  },

  //return exist tab id or undefined
  isExistTabpage(tabpage, allTabpages) {
    let mainMovie = tabpage.statusInfo.mainMovie
    let movieList = tabpage.statusInfo.movieList
    let code = undefined
    //type : index || movieLib
    if (!tabpage.type === 'movies') {
      let index = findIndex(allTabpages, function (o) {
        return o.type === tabpage.type
      })
      if (index >= 0) {
        code = allTabpages[index].statusCode
        return code
      } else {
        return undefined
      }
    }

    //type : movies: single || multi || cycle
    for (let index = 0; index < allTabpages.length; index++) {
      let curMovieList = allTabpages[index].statusInfo.movieList
      let curMainMovie = allTabpages[index].statusInfo.mainMovie
      if (isEqual(sortBy(movieList), sortBy(curMovieList)) && mainMovie === curMainMovie && tabpage.type === allTabpages[index].type) {
        code = allTabpages[index].statusCode
        break;
      }
    }
    return code
  },


}
export default tabpageStorageUtil